import { get } from 'lodash';
import PropTypes from 'prop-types';
import React, { useEffect, useState } from 'react';
import { Tab, Tabs } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import ResponsiveHeader from '../../../../shared/components/ResponsiveHeader';
import { CONTENT_APPROVAL_OPTIONS } from '../../../../utils/constants';
import DraftsSection from './DraftsSection';
import LivePostsSection from './LivePostsSection';
import OtherDeliverablesSection from './OtherDeliverablesSection';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router';

const PostingPhase = ({
  offer: {
    deliverables,
    other_deliverable_instructions: otherDeliverableInstructions,
    other_deliverable_label: otherDeliverableLabel,
    content_approval_option: contentApprovalOption,
    content_approval_enabled: contentApprovalEnabled
  }
}) => {
  const { t } = useTranslation();
  const offer = useSelector(store => get(store, 'offer.offer'));
  const userOffer = useSelector(store => get(store, 'offer.offer.user_offer'));
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const queryContentTab = queryParams.get('content_tab');

  const [state, setState] = useState({
    hasDeliverables: false,
    hasOtherDeliverables: false,
    hasLivePosts: false,
    contentApprovalOn: contentApprovalOption !== CONTENT_APPROVAL_OPTIONS.NO_CONTENT_APPROVAL || contentApprovalEnabled,
    contentTab: queryContentTab
  });

  useEffect(() => {
    setState({
      ...state,
      hasDeliverables: userOffer.has_deliverables,
      hasOtherDeliverables: !!deliverables.other,
      hasLivePosts: userOffer.has_live_posts,
    });
  }, [userOffer]);

  const showDeliverables = state.hasDeliverables && state.contentApprovalOn;
  const showOtherDeliverables = state.hasOtherDeliverables;
  const showLivePosts = state.hasLivePosts;
  const showTabs = (showDeliverables + showOtherDeliverables + showLivePosts) > 1;

  const firstAvailableTab = () => (
    showDeliverables
      ? "posts"
    : showLivePosts
      ? "live_posts"
    : showOtherDeliverables
      ? "other"
    : null
  );

  return (
    <div className='mb-6'>
      <ResponsiveHeader xs='h4' sm='h3'>
        {t('influencers.pages.campaign.posting_phase.content')}
      </ResponsiveHeader>

      {/* RENDER TABS IF MORE THAN ONCE  */}
      {showTabs ?
        <Tabs
          className="not-link my-5"
          bg="light"
          expand="xs"
          defaultActiveKey={state.contentTab || firstAvailableTab()}
        >
          {showDeliverables ?
            <Tab eventKey="posts" title={t('influencers.pages.campaign.posting_phase.drafts')}>
              <DraftsSection offer={offer} />
            </Tab>
            : null}
          {showLivePosts ?
            <Tab eventKey="live_posts" title={t('influencers.pages.campaign.posting_phase.live_posts')}>
              <LivePostsSection
                userOffer={userOffer} />
            </Tab>
            : null}
          {showOtherDeliverables ?
            <Tab eventKey="other" title={otherDeliverableLabel}>
              <OtherDeliverablesSection
                userOffer={userOffer}
                otherDeliverableInstructions={otherDeliverableInstructions} />
            </Tab>
            : null}
        </Tabs>
        : null}
      {/* RENDER NORMAL CONTENT IF THERE ARE NOT OTHER OPTIONS TO SHOW */}
      {!showTabs ?
        <React.Fragment>
          {showDeliverables ?
            <DraftsSection
              offer={offer}
            /> : null}
          {showOtherDeliverables ?
            <OtherDeliverablesSection
              userOffer={userOffer}
              otherDeliverableInstructions={otherDeliverableInstructions} />
            : null}
          {showLivePosts ?
            <LivePostsSection
              userOffer={userOffer} />
            : null}
        </React.Fragment > : null}
    </div >

  );
};

PostingPhase.propTypes = {
  offer: PropTypes.object.isRequired
};

export default PostingPhase;
